export const CREATE_ARTICLE_REQUEST = "CREATE_ARTICLE_REQUEST";
export const CREATE_ARTICLE_SUCCESS = "CREATE_ARTICLE_SUCCESS";
export const CREATE_ARTICLE_FAILURE = "CREATE_ARTICLE_FAILURE";

export const RESET_ARTICLE_VARIABLES = "RESET_ARTICLE_VARIABLES";

export const GET_ARTICLE_BY_CHAPTER_ID_REQUEST =
  "GET_ARTICLE_BY_CHAPTER_ID_REQUEST";
export const GET_ARTICLE_BY_CHAPTER_ID_SUCCESS =
  "GET_ARTICLE_BY_CHAPTER_ID_SUCCESS";
export const GET_ARTICLE_BY_CHAPTER_ID_FAILURE =
  "GET_ARTICLE_BY_CHAPTER_ID_FAILURE";
